import React from 'react'
import { StreamrTvBannerProvider } from './src/contexts/StreamrTvBannerContext'

// eslint-disable-next-line import/no-unused-modules
export const wrapRootElement = ({ element }) => (
    <StreamrTvBannerProvider>{element}</StreamrTvBannerProvider>
)
